import React from "react";

const PrivacyPolicy = () => {
  return (
    <div style={{ padding: "20px", fontFamily: "Arial, sans-serif" }}>
      <h1>Gizlilik Politikası</h1>
      <p><strong>Son Güncellenme Tarihi:</strong> 24.01.2025</p>

      <p>
        UM Ad Compliance Tool olarak, kullanıcılarımızın gizliliğine önem veriyoruz. Bu Gizlilik Politikası, Chrome uzantımızı kullandığınızda hangi verileri topladığımızı, bu verileri nasıl kullandığımızı ve koruduğumuzu açıklar.
      </p>

      <p>
        Lütfen bu politikayı dikkatlice okuyun. Uzantımızı kullanmaya devam ederek, bu Gizlilik Politikası’nı kabul etmiş sayılırsınız.
      </p>

      <hr />

      <h2>1. Topladığımız Veriler</h2>
      <p>
        Chrome uzantısı aracılığıyla doğrudan herhangi bir veri toplamayız. Uzantımız yalnızca web sitesi üzerinden tanımlanan kullanıcıların giriş yapmasına olanak tanır ve uzantı içinde kullanıcı kayıt işlemi gerçekleşmez. Araç, Meta, Google ve LinkedIn gibi platformlardaki reklam panellerinde kampanya girişlerini kontrol etmek üzere çalışır ve anlık işlem sağlar.
      </p>
      <p><strong>Önemli Not:</strong> Uzantımız, kullanıcıların tarama geçmişi, IP adresi, ödeme bilgileri, şifreler veya herhangi bir hassas kişisel veriyi toplamaz.</p>

      <hr />

      <h2>2. Verilerin Kullanım Amaçları</h2>
      <p>
        Uzantı ile doğrudan veri toplanmadığı için herhangi bir kişisel veri işlenmemektedir. Araç, yalnızca kullanıcıların yetkilendirilmiş hesapları üzerinden reklam panellerinde kontroller yapar.
      </p>

      <hr />

      <h2>3. Verilerin Paylaşımı</h2>
      <p>
        Verilerinizi üçüncü taraflarla paylaşmayız. Uzantı, yalnızca kullanıcının izin verdiği platformlarda işlem yapar ve hiçbir şekilde veri aktarımı gerçekleştirmez.
      </p>

      <hr />

      <h2>4. Verilerin Saklanması ve Korunması</h2>
      <p>
        Uzantımızda herhangi bir kullanıcı verisi saklanmamaktadır. Ancak, kullanıcıların güvenliğini sağlamak için aşağıdaki önlemleri alıyoruz:
      </p>
      <ul>
        <li>Kullanıcı giriş bilgileri yalnızca ilgili platformlara erişim için kullanılır ve uzantı tarafından saklanmaz.</li>
        <li>Uzantının tüm işlemleri güvenli bir ortamda gerçekleştirilir.</li>
      </ul>

      <hr />

      <h2>5. Kullanıcı Hakları</h2>
      <p>
        Kullanıcılar olarak aşağıdaki haklara sahipsiniz:
      </p>
      <ul>
        <li>Uzantı aracılığıyla herhangi bir veri toplanmadığı için kişisel verilerle ilgili işlem yapılmamaktadır.</li>
      </ul>
      <p>
        Bu konuda daha fazla bilgi almak için bizimle iletişime geçebilirsiniz: melih.erpek@umww.com
      </p>

      <hr />

      <h2>6. Değişiklikler</h2>
      <p>
        Bu Gizlilik Politikaları zaman zaman güncellenebilir. Politikadaki önemli değişiklikler, Chrome Uzantı Mağazası’ndaki açıklamalar veya doğrudan bildirimlerle paylaşılacaktır.
      </p>

      <hr />

      <h2>7. İletişim</h2>
      <p>
        Bu Gizlilik Politikaları ile ilgili sorularınız için bize aşağıdaki kanallardan ulaşabilirsiniz:
      </p>
      <ul>
        <li><strong>E-posta:</strong> melih.erpek@umww.com</li>
      </ul>

      <hr />

      <p>
        Uzantımızı kullandığınız için teşekkür ederiz! Gizliliğiniz bizim için çok önemlidir.
      </p>
    </div>
  );
};

export default PrivacyPolicy;
